export enum ProvisionerJourneyRoutes {
  SiteList = 'site-list',
}

export const ProvisionerModuleBaseRoute = 'provisioner';
